import {
  DELETE_INTEGRATION,
  DELETE_INTEGRATION_FAILURE,
  DELETE_INTEGRATION_SUCCESS,
  REQUEST_INTEGRATIONS_OVERVIEW,
  REQUEST_INTEGRATIONS_OVERVIEW_FAILURE,
  REQUEST_INTEGRATIONS_OVERVIEW_SUCCESS,
  SAVE_INTEGRATION,
  SAVE_INTEGRATION_FAILURE,
  SAVE_INTEGRATION_SUCCESS,
} from "../../utils/constants";

const initialMutation = {
  type: null,
  providerKey: null,
  connectionId: null,
  status: "idle",
  error: null,
};

const initialState = {
  overview: null,
  status: "idle",
  error: null,
  mutation: initialMutation,
};

const getMutation = (action, status, error = null) => ({
  type: action.payload?.mutationType || null,
  providerKey: action.payload?.providerKey || null,
  connectionId: action.payload?.connectionId || null,
  status,
  error,
});

export default function integrationReducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST_INTEGRATIONS_OVERVIEW:
      return { ...state, status: "loading", error: null };
    case REQUEST_INTEGRATIONS_OVERVIEW_SUCCESS:
      return {
        ...state,
        status: "succeeded",
        overview: action.payload,
        error: null,
      };
    case REQUEST_INTEGRATIONS_OVERVIEW_FAILURE:
      return {
        ...state,
        status: "failed",
        error: action.payload,
      };
    case SAVE_INTEGRATION:
      return {
        ...state,
        mutation: getMutation(
          { payload: { ...action.payload, mutationType: "save" } },
          "saving"
        ),
      };
    case SAVE_INTEGRATION_SUCCESS:
      return {
        ...state,
        mutation: getMutation(
          { payload: { ...action.payload, mutationType: "save" } },
          "succeeded"
        ),
      };
    case SAVE_INTEGRATION_FAILURE:
      return {
        ...state,
        mutation: getMutation(
          { payload: { ...action.payload, mutationType: "save" } },
          "failed",
          action.payload?.error || action.payload
        ),
      };
    case DELETE_INTEGRATION:
      return {
        ...state,
        mutation: getMutation(
          { payload: { ...action.payload, mutationType: "delete" } },
          "deleting"
        ),
      };
    case DELETE_INTEGRATION_SUCCESS:
      return {
        ...state,
        mutation: getMutation(
          { payload: { ...action.payload, mutationType: "delete" } },
          "succeeded"
        ),
      };
    case DELETE_INTEGRATION_FAILURE:
      return {
        ...state,
        mutation: getMutation(
          { payload: { ...action.payload, mutationType: "delete" } },
          "failed",
          action.payload?.error || action.payload
        ),
      };
    default:
      return state;
  }
}

